"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLabel = exports.ViewContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.ViewContainer = native_1.default.View `
  flex-direction: row;
  padding-top: 7px;
  justify-content: ${({ justify }) => justify};
`;
exports.ErrorLabel = native_1.default.Text `
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme, status }) => theme.color.state[status]};
`;
